"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signTypedMessagePrivateKey = exports.signTypedMessage = exports.recoverTypedSignatureAddress = void 0;
const eth_sig_util_1 = __importDefault(require("eth-sig-util"));
const getData = (text) => {
    return {
        types: {
            EIP712Domain: [
                { name: 'name', type: 'string' },
                { name: 'version', type: 'string' }
            ],
            TextInformation: [{ name: 'text', type: 'string' }]
        },
        domain: {
            name: 'Origin',
            version: '2'
        },
        primaryType: 'TextInformation',
        message: {
            text
        }
    };
};
function recoverTypedSignatureAddress(text, signedMessage) {
    return __awaiter(this, void 0, void 0, function* () {
        return eth_sig_util_1.default.recoverTypedSignature({
            sig: signedMessage,
            data: getData(text)
        });
    });
}
exports.recoverTypedSignatureAddress = recoverTypedSignatureAddress;
function signTypedMessage(from, text, web3) {
    return __awaiter(this, void 0, void 0, function* () {
        return web3.send('eth_signTypedData_v4', [from, JSON.stringify(getData(text))]);
    });
}
exports.signTypedMessage = signTypedMessage;
function signTypedMessagePrivateKey(privateKey, text) {
    return __awaiter(this, void 0, void 0, function* () {
        return eth_sig_util_1.default.signTypedData(Buffer.from(privateKey, 'hex'), { data: getData(text) });
    });
}
exports.signTypedMessagePrivateKey = signTypedMessagePrivateKey;
//# sourceMappingURL=Signing.js.map